/** API endpoints used by the services in src/services/api/, relative to getBaseSalesURL(). */
export enum ApiEndpoints {
    AUTH = 'auth',
    AUTH_ADFS_LOGOUT = 'auth/adfs/logout',
    BALCONY_LENGTH = 'balcony-length',
    BATTERY = 'battery',
    BOX_CONNECTION_TYPE = 'box-connection-type',
    BUSINESS_MODELS = 'business-models',
    CHANNELS = 'channels',
    CHARGING_POWER = 'charging-power',
    CHARGING_POWER_VALIDATE = 'charging-power/validate',
    CLIENT = 'client',
    CONTRACTED_POWER = 'contracted-power',
    CPES = 'cpes',
    DISCOUNT_CODE = 'discount-code',
    DISTANCE_PARKING_SPOTS = 'distance-parking-spots',
    DISTANCE_PARKING_SPOTS_QP = 'distance-parking-spots-qp',
    DISTANCE_RANGES = 'distance-ranges',
    EFFICIENCY_MEASURES = 'efficiency-measures',
    ELECTRIC_INSTALLATION_TYPE = 'electric-installation-type',
    ELECTRICAL_CHAIN = 'electrical-chain',
    EQUIPMENT = 'equipment',
    EQUIPMENT_HOURLY_PERIOD = 'equipment-hourly-period',
    EQUIPMENT_HOURLY_PERIOD_MEAL = 'equipment-hourly-period-meal',
    EQUIPMENT_SEASON = 'equipment-season',
    EQUIPMENT_TYPES = 'equipment/types',
    EQUIPMENT_UTILIZATION_FREQUENCY = 'equipment-utilization-frequency',
    EV_MODELS = 'ev-models',
    FIRST_ARRIVALS = 'first-arrivals',
    FUTURE_EQUIPMENTS = 'future-equipments',
    HOURLY_OPTIONS = 'hourly-options',
    IMG_CONTRACT = 'img-contract',
    INSTALLATION_CONNECTION = 'installation-connection',
    INSTALLATION_SITE = 'installation-site',
    INVERTER_TYPE = 'inverter-type',
    MAIN_ELECTRICAL_PANEL = 'main-electrical-panel',
    NETWORK_CONNECTION = 'network-connection',
    NETWORK_CONNECTION_TYPES = 'network-connection/types',
    NIF = 'nif',
    NIF_EVC = 'nif/evc',
    PARTNERS = 'partners',
    PRODUCT = 'product',
    PROPERTY_OWNER_TYPE = 'property-owner-type',
    PUMPING_DURATION = 'pumping-duration',
    REPORTING = 'reporting',
    SALES_POINT = 'sales-point',
    SIMULATION_STATUS = 'simulation-status',
    SIMULATIONS = 'simulations',
    SIMULATIONS_AUDIT_FILES = 'simulations/audit-files',
    SIMULATIONS_DOWNLOAD_CSV = 'simulations/download-csv',
    SIMULATIONS_SOLARPV = 'simulations/solarpv',
    SIMULATIONS_UPSELL = 'simulations/upsell',
    SPACE_TYPE = 'space-type',
    SUPERVISORS = 'supervisors',
    USER = 'user',
    USER_ACCOUNT = 'user-account',
    USER_ACCOUNT_EMAIL = 'user-account/email',
    USER_ACCOUNT_USERNAME = 'user-account/username',
    USER_AUTH_MODES = 'user/auth-modes',
    USER_CREDENTIALS_EMAIL = 'user/credentials-email',
    USER_DETAILS = 'user-details',
    USER_MANAGEMENT_PARTNERS = 'user-management-partners',
    USER_MANAGEMENT_SALES_POINT = 'user-management-sales-point',
    USER_TYPE = 'user-type',
    WEEKEND_IN_HOUSE = 'weekend-in-house',
    WORK_DAYS_OCCUPATION_PERIOD = 'work-days-occupation-period',
}
